import { Tag } from '@grupoboticario/flora-react';
import { Card } from 'ui/components/primitives';
import { mixins, styled, theme, utils } from 'ui/theme';

export const ProductCard = {
  BlockedToSellTag: styled(Tag)`
    width: 100%;
  `,

  Card: styled(Card)`
    ${mixins.baseFont};
    align-items: end;
    color: ${theme.colors.build.darkLight};
    grid-template-rows: unset;
    max-width: ${theme.screens.s};
    overflow: hidden;
    position: relative;
    margin: 0;
    ${utils.transition('all').easing('easeInOut').duration('shortest')};

    &[data-link='true'] {
      &:hover {
        box-shadow: 0px 0px 0px 1px ${theme.colors.action.navigation.standard.static};
      }
    }
  `,

  Code: styled('span')`
    background: ${theme.colors.build.lightDark1};
    border-radius: ${theme.radii.small};
    color: ${theme.colors.build.darkLight};
    font-size: ${theme.fontSizes.sm};
    grid-area: code;
    padding: ${theme.space[1]};
    width: fit-content;
  `,

  ListPricesWrapper: styled('div')`
    margin: 0 0 ${theme.space[4]};
    min-height: calc(${theme.sizes[2]} + ${theme.sizes[23]});
  `,

  PriceTitle: styled('span')`
    font-size: ${theme.fontSizes.sm};
  `,

  PriceWrapper: styled('div')`
    align-items: center;
    border-radius: ${theme.radii.small};
    background: ${theme.colors.build.lightDark1};
    display: flex;
    justify-content: space-between;
    margin: ${theme.space[1]} ${theme.space[0]};
    padding: ${theme.space[2]};
  `,

  PriceValue: styled('div')`
    align-items: center;
    display: inline-flex;
    font-size: ${theme.fontSizes.sm};
    margin: ${theme.space[0]};

    &[data-max] {
      font-size: ${theme.fontSizes.lg};
    }
  `,
  OldValue: styled('div')`
    font-size: 11px;
    text-decoration: line-through;
    padding-right: 10px;
    margin: ${theme.space[0]};
    color: #878787;
  `,

  PriceValueMobile: styled('div')`
    display: block;
    font-size: ${theme.fontSizes.sm};
    text-align: right;
    margin: ${theme.space[0]};
    &[data-max] {
      font-size: ${theme.fontSizes.lg};
    }
  `,
  OldValueMobile: styled('div')`
    font-size: 10px;
    text-decoration: line-through;
    margin: ${theme.space[0]};
    color: #878787;
  `,

  Tags: styled('div')`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.space[1]};
    margin: ${theme.space[0]} ${theme.space[0]} ${theme.space[4]};
    max-width: ${theme.screens.s};
    min-height: ${theme.sizes[6]};
  `,

  TagDiscount: styled(Tag)`
    position: absolute;
    top: 16px;
    z-index: 2;
    align-items: center;
    border-radius: ${theme.radii.small};
    color: ${theme.colors.build.lightLight};
    display: inline-block;
    font-family: ${theme.fonts.secondary};
    font-size: 13px;
    font-weight: ${theme.fontWeights.light};
    line-height: ${theme.lineHeights.none};
    padding: ${theme.space[1]} ${theme.space[2]};
    background: ${theme.colors.action.nonInteractive.emphasis};
  `,

  Title: styled('span')`
    ${utils.lineClamp(2)}
    color: ${theme.colors.build.darkLight};
    font-size: ${theme.fontSizes.md};
    height: ${theme.sizes[12]};
    line-height: ${theme.sizes[6]};
    margin: ${theme.space[1]} ${theme.space[0]} !important;
  `,

  UnavailableStripe: styled('span')`
    background: ${theme.colors.build.mediumLight1};
    color: ${theme.colors.build.lightLight};
    display: block;
    margin-bottom: ${theme.space[4]};
    margin-top: calc(-1 * ${theme.space[10]});
    opacity: 90%;
    padding: ${theme.space[3]} ${theme.space[2]};
    text-align: center;
    transform: translate(calc(-1 * ${theme.space[4]}), 0);
    width: calc(100% + ${theme.space[8]});

    &[data-departament-slider] {
      margin-top: -58px;
    }
  `,
};

export const SkeletonCard = {
  Button: styled('div')`
    width: 100%;
    height: ${theme.sizes[12]};
    margin-top: ${theme.space[4]};
  `,

  Card: styled(Card)`
    max-width: ${theme.screens.s};
  `,

  Code: styled('div')`
    grid-area: code;
    height: ${theme.sizes[5]};
    margin: ${theme.space[1]} 0;
    width: ${theme.sizes[23]};
  `,

  Image: styled('div')`
    height: calc(${theme.sizes[18]} * 2);
    width: 100%;

    ${utils.media.min('l')`
      min-width: calc(${theme.sizes[18]} * 3);
      height: calc(${theme.sizes[18]} * 3);
    `}
  `,

  PriceWrapper: styled('div')`
    height: ${theme.sizes[8]};
    margin: ${theme.space[1]} ${theme.space[0]};
    padding: 0;
    width: 100%;

    &:nth-of-type(2),
    &:nth-last-of-type(1) {
      margin: 0;
    }
  `,

  Tags: styled('div')`
    margin: ${theme.space[0]} ${theme.space[0]} ${theme.space[4]};
    max-width: ${theme.screens.s};
    min-height: ${theme.sizes[6]};
  `,

  Tag: styled('div')`
    display: inline-block;
    height: ${theme.sizes[5]};
    margin-bottom: ${theme.space[1]};
    margin-right: ${theme.space[1]};
    width: ${theme.sizes[12]};
  `,

  Title: styled(ProductCard.Title)``,
};
